import { render, staticRenderFns } from "./AmountOfAssetsTableCell.vue?vue&type=template&id=0a9c776b&scoped=true"
import script from "./AmountOfAssetsTableCell.vue?vue&type=script&lang=js"
export * from "./AmountOfAssetsTableCell.vue?vue&type=script&lang=js"
import style0 from "./AmountOfAssetsTableCell.vue?vue&type=style&index=0&id=0a9c776b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9c776b",
  null
  
)

export default component.exports